import './ChangeLimitInput.css';
import { type TEditCardProps } from '../ChangeDescriptionInput/ChangeDescriptionInput';
import { ControlledInput } from '../../../../../../../../components/ControlledInput/ControlledInput';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

export const ChangeLimitInput: FC<TEditCardProps> = ({
  id,
  currentId,
  defaultValue,
  name,
  placeholder,
  rules,
}) => {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <>
      {id !== null && currentId !== null && id === currentId ? (
        <ControlledInput
          inputStyle={{
            padding: '4px 6px',
            color: '#2c2e35',
            border: errors[name] ? '1px solid #fe5b37' : '1px solid #1890ff',
            borderRadius: '2px',
          }}
          defaultValue={defaultValue}
          placeholder={placeholder}
          name={name}
          type={'text'}
          rules={{ ...rules, required: true, maxLength: rules?.maxLength || 13 }}
          transform={(text: string | undefined) => {
            if (text) {
              return text
                .replace(/[^0-9]/g, '')
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
                .slice(0, 13);
            }
            return text;
          }}
        />
      ) : (
        defaultValue
      )}
    </>
  );
};
